import { render, staticRenderFns } from "./Onboarding.vue?vue&type=template&id=0e9ea021&scoped=true"
import script from "./Onboarding.vue?vue&type=script&lang=js"
export * from "./Onboarding.vue?vue&type=script&lang=js"
import style0 from "./Onboarding.vue?vue&type=style&index=0&id=0e9ea021&prod&scoped=true&lang=css"
import style1 from "./Onboarding.vue?vue&type=style&index=1&id=0e9ea021&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9ea021",
  null
  
)

export default component.exports